<template>
  <fb-list-body :pager="pager" :showSearchForm="true" :showBtnGroup="true"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="btn-group">
      <el-button icon="el-icon-plus" @click="$router.push('/fitting-add')">{{$t('lang.新增')}}</el-button>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{$t('lang.删除')}}</el-button>
    </template>

    <template slot="search-form">
      <div @keyup.enter="handleSearch">
        <el-form-item class="search-form-item" :label="$t('lang.配件编号')">
          <el-input :placeholder="$t('lang.配件编号')" v-model="searchForm.number" clearable></el-input>
        </el-form-item>

        <el-form-item class="search-form-item" :label="$t('lang.配件名称')">
          <el-input :placeholder="$t('lang.配件名称')" v-model="searchForm.name" clearable></el-input>
        </el-form-item>

        <el-form-item class="search-form-item" label="">
          <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{$t('lang.搜索')}}</el-button>
          <el-button size="mini" type="primary" @click.stop="handleReset">{{ $t('lang.重置') }}</el-button>
        </el-form-item>
      </div>
    </template>


    <template slot="table">

      <el-table :data="tableData" @selection-change="handleSelectionChange" @row-dblclick="handleEdit">

        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column type="index" width="50"></el-table-column>

        <el-table-column :label="$t('lang.配件图片')">
          <template slot-scope="scope">
            <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.photo"/>

          </template>
        </el-table-column>
        <el-table-column prop="accessoryNumber" :label="$t('lang.配件编号')"></el-table-column>
        <el-table-column prop="name" :label="$t('lang.配件名称')"></el-table-column>
        <el-table-column fixed="right" :label="$t('lang.操作')" width="280">
          <template slot-scope="scope">
            <el-button size="mini" @click='$router.push({path: "/fitting-edit",query: {code: scope.row.accessoryCode} });' plain
                       type="primary">{{ $t('lang.编辑') }}
            </el-button>
            <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{ $t('lang.删除') }}</el-button>
          </template>
        </el-table-column>


      </el-table>
    </template>


  </fb-list-body>
</template>

<script>
export default {
  name: "FittingList",
  components: {},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.accessory.list,
        delete: this.$api.accessory.delete,
        batchDelete: this.$api.accessory.batchDelete,
        download: this.$api.file.download,
      },
      searchForm: {},
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      }
    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    }
  },
  watch: {
    timestamp() {
      this.handleGetData();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {

        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true
    }

  },
  methods: {
    handleSearch() {
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleGetData();
    },
    handleReset() {
      if(Object.keys(this.searchForm).length) {
        this.searchForm = {};
        this.pager.pageIndex = 1;
        this.pager.pageSize = 10;
        this.pager.itemCount = 0;
        this.handleGetData();
      }
    },

    handleEdit(e) {

      if (e && e.code) {
        this.$router.push({
          path: 'edit',
          query: {
            code: e.code
          }
        });
        return;
      }

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.未选择记录')
        });
        return;
      }

      if (this.selection.length > 1) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.一次只能编辑一条数据')
        });
        return;
      }

      this.$router.push({
        path: 'edit',
        query: {
          code: this.selection[0].code
        }
      });
    },
    handleDelete(row) {
      let vm = this;
      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.get(vm.api.delete, {params: {code: row.accessoryCode}}).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });

    },
    handleBatchDelete() {
      let vm = this;
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }


      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.accessoryCode);
      });


      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(this.api.batchDelete, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });


    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleGetData() {
      let vm = this;
      this.$http.get(this.api.list, {params: this.searchParams}).then((resp) => {

        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
            vm.tableData.forEach(t => t.photo = this.api.download + '?fileCode=' + t.photo)
          }
        }

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;

      })
    }
  },
  created() {

    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
}
</script>

<style scoped>

</style>
